import { Button, Form, FormProps } from "antd";
import React from "react";
import { update } from "../firebase";
import TextArea from "antd/es/input/TextArea";

export type SettingsType = {
  description: string;
};

const SettingsForm: React.FC<{ description?: string, close: () => void }> = ({ description, close }) => {
  const onFinish: FormProps<SettingsType>["onFinish"] = async (values) => {
    await update("settings", "public", { description: values.description || "" });
    close();
  };

  return (
    <>
      <Form
        key="settings"
        name="settings"
        initialValues={{
          description,
        }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Champ requis" }]}
        >
          <TextArea
            autoSize={{ minRows: 3 }}
          />
        </Form.Item>

        <Form.Item style={{ textAlign: "center" }}>
          <Button type="primary" htmlType="submit">
            Sauvegarder
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default SettingsForm;
